import React from 'react';
import './Fitticorros.css';
import fittingImage from '../../../imgs/Fitticorro.webp'; 

const Fitticorros = () => {
  return (
    <div className="fittingcorros-container" data-aos="fade-down">
      <img src={fittingImage} alt="Fitting Corrosion" className="fittingcorros-image" />
    </div>
  );
};

export default Fitticorros;
